import React from "react";

const whatsappNumber = "919886008882";
const whatsappMessage =
  "Hello Anand Technologies, I would like to know more about your products.";

const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
  whatsappMessage
)}`;

function WhatsAppButton() {
  return (
    <a
      href={whatsappUrl}
      className="whatsapp-float"
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
    >
      <span className="whatsapp-float-icon" aria-hidden="true">
        <svg viewBox="0 0 32 32" fill="currentColor">
          <path d="M19.11 17.38c-.27-.14-1.61-.79-1.86-.88-.25-.09-.43-.14-.61.14-.18.27-.7.88-.85 1.06-.16.18-.31.2-.58.07-.27-.14-1.12-.41-2.13-1.31-.79-.7-1.32-1.56-1.47-1.82-.16-.27-.02-.41.12-.54.12-.12.27-.31.41-.47.14-.16.18-.27.27-.45.09-.18.05-.34-.02-.47-.07-.14-.61-1.47-.84-2.01-.22-.53-.44-.46-.61-.47h-.52c-.18 0-.47.07-.72.34-.25.27-.95.93-.95 2.27s.98 2.64 1.11 2.82c.14.18 1.92 2.93 4.66 4.11.65.28 1.16.45 1.56.57.66.21 1.27.18 1.75.11.53-.08 1.61-.66 1.84-1.3.23-.63.23-1.18.16-1.29-.07-.11-.25-.18-.52-.32Z" />
          <path d="M16.03 3.2c-7.06 0-12.77 5.71-12.77 12.75 0 2.25.59 4.45 1.72 6.38L3.2 28.8l6.63-1.74a12.8 12.8 0 0 0 6.2 1.58h.01c7.04 0 12.76-5.71 12.76-12.76 0-3.41-1.33-6.61-3.75-9.03A12.67 12.67 0 0 0 16.03 3.2Zm0 23.29h-.01a10.7 10.7 0 0 1-5.45-1.49l-.39-.23-3.93 1.03 1.05-3.83-.25-.4a10.63 10.63 0 0 1-1.64-5.61c0-5.89 4.8-10.69 10.71-10.69 2.86 0 5.55 1.11 7.57 3.13a10.64 10.64 0 0 1 3.14 7.57c0 5.9-4.8 10.7-10.7 10.7Z" />
        </svg>
      </span>
      <span className="whatsapp-float-label">WhatsApp Us</span>
    </a>
  );
}

export default WhatsAppButton;
